var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("Report Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Reporting")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.featureForm.report,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "report", $$v)
                  },
                  expression: "featureForm.report",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "basic-report" } }, [
                  _vm._v("Basic Reporting"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "detail-report" } }, [
                  _vm._v("Detail Reporting"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.visitorTracking,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "visitorTracking", $$v)
                  },
                  expression: "featureForm.visitorTracking",
                },
              },
              [_vm._v("Visitor Reporting")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.specialReport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "specialReport", $$v)
                  },
                  expression: "featureForm.specialReport",
                },
              },
              [_vm._v("Özel Raporlama")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }